<div class="calculation-cell"
     [style.font-size.px]="fontSize"
     [style.font-weight]="fontWeight">
  <ng-container *ngIf="!hasOverride">
    <span class="calc-label" *ngIf="label">{{ label }}</span>
    <span class="calc-value" [class.no-value]="calculatedValue === null">
      {{ calculatedValue !== null ? formattedValue : '--' }}
    </span>
  </ng-container>
  <span *ngIf="hasOverride" class="calc-value">{{ formattedValue }}</span>
</div>
